import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { FormattedMessage } from 'react-intl';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import Parallax from 'parallax-js';
import smoothScroll from 'smoothscroll';
import ismobilejs from 'ismobilejs';

import './Hero.css';

class Hero extends React.Component {

  static propTypes = {
    className: PropTypes.string
  };

  state = {
    isLoaded: false
  };

  render() {
    return (
      <div className={classnames('Hero', this.props.className)}>
        <div 
          className="Hero__bgContainer"
          ref={container => { this._container = container; }}>
          <div
            className="Hero__bgDepth"
            data-depth={ismobilejs.any ? `0.3` : `0.1`}>
            <img
              className={classnames('Hero__bg', {
                'Hero__bg--loaded': this.state.isLoaded
              })}
              src={require('../images/Hero-earth.jpg')}
              alt="Hansuk International LTD."
              onLoad={this._onLoad}
            />
          </div>
        </div>
        <div className="Hero__content">
          <ReactCSSTransitionGroup
            transitionName="transition"
            transitionAppear={true}
            transitionAppearTimeout={2400}
            transitionEnter={false}
            transitionLeave={false}>
            <div className="Hero__labels">
              <div className="Hero__subtitle">
                <FormattedMessage id="Hero.subtitle"/>
              </div>
              <h1 className="Hero__title">
                <FormattedMessage id="Hero.title"/>
              </h1>
            </div>
          </ReactCSSTransitionGroup>
        </div>
        <div
          className="Hero__downArrowIcon"
          onClick={this._onClickDownArrow}>
          <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 64 64">
            <path d="M11.75,31.0600448 L11.75,1 C11.75,0.585786438 11.4142136,0.25 11,0.25 C10.5857864,0.25 10.25,0.585786438 10.25,1 L10.25,31.0600448 L1.55495506,21.4954954 C1.27632486,21.1890022 0.801988618,21.1664148 0.495495405,21.4450449 C0.189002191,21.7236751 0.166414751,22.1980114 0.445044945,22.5045046 L11,34.1149552 L21.5549551,22.5045046 C21.8335852,22.1980114 21.8109978,21.7236751 21.5045046,21.4450449 C21.1980114,21.1664148 20.7236751,21.1890022 20.4450449,21.4954954 L11.75,31.0600448 Z" transform="translate(21 14)"/>
          </svg>
        </div>
      </div>
    );
  }

  componentDidMount() {
    new Parallax(this._container, {
      relativeInput: false,
      clipRelativeInput: false,
      hoverOnly: false,
      calibrateX: false,
      calibrateY: true,
      invertX: true,
      invertY: true,
      limitX: false,
      limitY: false,
      scalarX: 10.0,
      scalarY: 10.0,
      frictionX: 0.1,
      frictionY: 0.1,
      originX: 0.5,
      originY: 0.5,
      precision: 1,
      pointerEvents: false
    });
  }

  _onLoad = () => {
    this.setState({
      isLoaded: true
    });
  };

  _onClickDownArrow = () => {
    const anchor = document.querySelector('.Story');
    smoothScroll(anchor);
  };

}

export default Hero;



// WEBPACK FOOTER //
// ./src/components/Hero.js